export default "__VITE_ASSET__C8t$L$EI__"